<template>
    <div>
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 class="h2">Tableau de bord</h1>
        </div>

        <div class="row pb-4">
            <div class="col-lg-6 alignContent">
                <div class="card">
                    <div class="card-header">PVs et Quittances non intégrés</div>
                    <div class="card-body">
                        <h1 class="card-title pricing-card-title">{{ this.totalTrashChannel }} <i
                                class="fas fa-search h6" @click="openModalNotIntegrate()"/></h1>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 alignContent">
                <div class="card">
                    <div class="card-header">Total de PVs et Quittances non exportés</div>
                    <div class="card-body">
                        <h1 class="card-title pricing-card-title">{{ this.arrayViolationNotExport.length }} <i
                                class="fas fa-search h6" @click="openModalNotExported()"/></h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-4 pt-2 ">
                Filtrer par ligne :
                <v-select class="select background-alt" :options="lines" v-model="line"/>
            </div>
        </div>

        <div class="row background-alt mb-3">
            <div class="col-lg-12"><br>
                <div class="card">
                    <div class="card-body">
                        <vue-element-loading :active="isActiveChart1" spinner="spinner" class="customLoader" color="#a3285e"/>

                        <bar-chart :chart-data="chartControlClientsByJustificatoryByDay"
                                   :title-chart="chart1"
                                   :display-legend="true"
                                   chartId="bar-chart-1"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="row background-alt mt-3 mb-3">
            <div class="col-lg-6"><br>
                <div class="card">
                    <div class="card-body">
                        <vue-element-loading :active="isActiveChart2" spinner="spinner" class="customLoader" color="#a3285e"/>

                        <bar-chart :chart-data="chartOfficerWithSessionByDay"
                                   :title-chart="chart2"
                                   :display-legend="false"
                                   chartId="bar-chart-1"
                        />
                    </div>
                </div>
            </div>
            <div class="col-lg-6"><br>
                <div class="card">
                    <div class="card-body">
                        <vue-element-loading :active="isActiveChart3" spinner="spinner" class="customLoader" color="#a3285e"/>

                        <bar-chart :chart-data="chartPdaWithSessionByDay"
                                   :title-chart="chart3"
                                   :display-legend="false"
                                   chartId="bar-chart-1"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="row background-alt mt-3 pb-4">
            <div class="col-lg-6"><br>
                <div class="card">
                    <div class="card-body">
                        <vue-element-loading :active="isActiveChart4" spinner="spinner" class="customLoader" color="#a3285e"/>

                        <bar-chart :chart-data="chartFineAndIfByDay"
                                   :title-chart="chart4"
                                   :display-legend="true"
                                   chartId="bar-chart-1"
                        />
                    </div>
                </div>
            </div>
            <div class="col-lg-6"><br>
                <div class="card">
                    <div class="card-body">
                        <vue-element-loading :active="isActiveChart5" spinner="spinner" class="customLoader" color="#a3285e"/>

                        <bar-chart :chart-data="chartRatioControlAndFineByDay"
                                   :title-chart="chart5"
                                   chartId="bar-chart-1"
                        />
                    </div>
                </div>
            </div>
        </div>

        <modal :showModal="showModalNotExported" :hideModal="hideModalNotExported" :openModal="openModalNotExported">
            <h5 slot="header">
                Remontée en erreur Tigre
            </h5>

            <span slot="body" class="w-100">
                <div v-for="violation in arrayViolationNotExport">
                    <div class="row col-lg-12">
                        <div class="col-10">
                        {{ violation.type === 'Quittance' ? 'Quittance'  : 'PV' }} numéro {{ violation.type === 'Quittance' ? violation.if_id : violation.fine_id}}
                        {{ violation.type === 'Quittance' ? 'créée'  : 'créé' }}
                        {{ violation.created_at}}
                        </div>
                        <div class="col-2 btnDetails">
                            <i v-if="violation.type === 'Quittance'" class="fas fa-search" @click="openIfDetailsModal(violation.id)"/>
                            <i v-else class="fas fa-search" @click="openFineDetailsModal(violation.id)"/>
                        </div>
                    </div>
                    <hr>
                </div>
            </span>

            <span slot="footer">
                <button class="btn btn-danger" @click="hideModalNotExported">Fermer </button>
            </span>
        </modal>

        <modal :showModal="showModalNotIntegrate" :hideModal="hideModalNotIntegrate" :openModal="openModalNotIntegrate">
            <h5 slot="header">
                Remontée en erreur
            </h5>

            <span slot="body" class="w-100">
                <div v-for="trashChannel in arrayTrashChannels">
                   <div class="row col-lg-12">
                        <div class="col-10">{{ trashChannel.key === 'IF' ? 'Quittance créée le' : 'PV créé le' }} {{ formatDate(trashChannel.date_time) }}</div>
                        <div class="col-2 btnDetails">
                            <i class="fas fa-search" @click="openModalDetail(trashChannel)"/>
                        </div>
                    </div>
                    <hr>
                </div>
            </span>

            <span slot="footer">
                <button class="btn btn-danger" @click="hideModalNotIntegrate">Fermer </button>
            </span>
        </modal>

        <modal :showModal="showModalDetail" :hideModal="hideModalDetail" :openModal="openModalDetail">
            <h5 slot="header">
                Détail {{ this.currentTrashChannel.key }}
            </h5>

            <span slot="body" class="w-100">
                <div class="divDisplay">
                    <pre lang="xml">{{ this.currentTrashChannel.data }}</pre>
                </div>
            </span>

            <span slot="footer">
                <button class="btn btn-danger" @click="hideModalDetail">Fermer </button>
            </span>
        </modal>

        <fine-details-modal
                v-if="fineId"
                :showModal="showFineDetailsModal"
                :openModal="openFineDetailsModal"
                :closeModal="closeFineDetailsModal"
                :fineId="fineId"
        />

        <if-details-modal
                v-if="ifId"
                :showModal="showIfDetailsModal"
                :openModal="openIfDetailsModal"
                :closeModal="closeIfDetailsModal"
                :ifId="ifId"
        />

        <infringement-search-result-modal></infringement-search-result-modal>

    </div>
</template>

<script>

    import BarChart from './layout/BarChart';
    import moment from 'moment';
    import axios from 'axios';
    import vSelect from 'vue-select';
    import VueElementLoading from 'vue-element-loading';
    import Modal from './layout/Modal';
    import vkbeautify from 'vkbeautify';
    import InfringementSearchResultModal from "./layout/InfringementSearchResultModal";
    import FineDetailsModal from "./layout/FineDetailsModal.vue";
    import IfDetailsModal from "./layout/IfDetailsModal.vue";

    export default {
        components: {
            IfDetailsModal,
            FineDetailsModal, BarChart, vSelect, VueElementLoading, Modal, InfringementSearchResultModal},
        data() {
            return {
                chartOfficerWithSessionByDay: {},
                chartPdaWithSessionByDay: {},
                chartControlClientsByJustificatoryByDay: {},
                chartFineAndIfByDay: {},
                chartRatioControlAndFineByDay: {},
                dateStart: '',
                dateEnd: '',
                lines: [],
                line: '',
                arrayViolationNotExport: [],
                totalTrashChannel: 0,
                arrayTrashChannels: [],
                test: '',

                chart1: 'Nombre de clients par type de contrôle',
                chart2: 'Vérificateurs en activité',
                chart3: 'PDC en activité',
                chart4: 'Nombre d\'amendes',
                chart5: 'Taux de fraude',

                isActiveChart1: true,
                isActiveChart2: true,
                isActiveChart3: true,
                isActiveChart4: true,
                isActiveChart5: true,

                showModalNotIntegrate: false,
                showModalNotExported: false,
                showModalDetail: false,
                currentTrashChannel: {},
                data: '',

                fineId: null,
                showFineDetailsModal: false,

                ifId: null,
                showIfDetailsModal: false,
            }
        },
        created() {
            this.line = {id: 0, label: 'Toutes les lignes'};
            this.getLine();
            this.getTotalOfTrashChannel();
            this.getTotalOfViolationNotExported();
            this.getDate();
        },
        watch: {
            line: function () {
                this.isActiveChart1 = true;
                this.isActiveChart2 = true;
                this.isActiveChart3 = true;
                this.isActiveChart4 = true;
                this.isActiveChart5 = true;

                this.getTotalOfDifferentChecksByDay();
                this.getOfficerWithSessionByDay();
                this.getPdaWithSessionByDay();
                this.getFineAndIfByDay();
                this.getChartRatioControlAndFineByDay();
            }
        },
        methods: {
            getDate() {
                this.dateStart = moment().subtract(7, 'd').format('YYYY-MM-DD');
                this.dateEnd = moment().subtract(1, 'd').format('YYYY-MM-DD');
            },

            async getLine() {
                let lines = await axios.get('/api/lines');
                this.lines = lines.data;
                this.lines.unshift({id: 0, label: 'Toutes les lignes'});
            },

            getTotalOfDifferentChecksByDay() {
                axios.get('/api/dashboard/getTotalOfDifferentChecksByDay?start=' + this.dateStart + '&end='
                    + this.dateEnd + '&line=' + this.line.id)
                    .then(result => {
                        let dataChart = {
                            labels: [],
                            datasets: [
                                {
                                    label: '',
                                    backgroundColor: "#048BA8",
                                    data: []
                                },
                                {
                                    label: '',
                                    backgroundColor: "#f87979",
                                    data: []
                                },
                                {
                                    label: '',
                                    backgroundColor: '#185578',
                                    data: []
                                },
                                {
                                    label: '',
                                    backgroundColor: '#2E8B57',
                                    data: []
                                }
                            ]
                        };
                        _.forEach(result.data, value => {
                            dataChart.labels.push(value.interval); //moment(value.interval.date).format('DD/MM/YYYY'));

                            let i = 0;
                            _.forEach(value.checks, check => {
                                dataChart.datasets[i].label = check.title;
                                dataChart.datasets[i].data.push(check.total);
                                i++;
                            });
                        });
                        this.chartControlClientsByJustificatoryByDay = dataChart;
                        this.isActiveChart1 = false;
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            getOfficerWithSessionByDay() {
                axios.get('/api/dashboard/officerWithSessionByDay?start=' + this.dateStart + '&end=' + this.dateEnd
                    + '&line=' + this.line.id)
                    .then(result => {
                        let dataChart = {
                            labels: [],
                            datasets: [
                                {
                                    label: '',
                                    backgroundColor: '#2E8B57',
                                    data: []
                                }
                            ]
                        };
                        _.forEach(result.data, value => {
                            dataChart.labels.push(value.interval); //moment(value.interval.date).format('DD/MM/YYYY'));
                            dataChart.datasets[0].data.push(value.value);
                        });
                        this.chartOfficerWithSessionByDay = dataChart;
                        this.isActiveChart2 = false;
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            getPdaWithSessionByDay() {
                axios.get('/api/dashboard/pdaWithSessionByDay?start=' + this.dateStart + '&end=' + this.dateEnd
                    + '&line=' + this.line.id)
                    .then(result => {
                        let dataChart = {
                            labels: [],
                            datasets: [
                                {
                                    label: 'PDC en activité',
                                    backgroundColor: "#f87979",
                                    data: []
                                }
                            ]
                        };
                        _.forEach(result.data, value => {
                            dataChart.labels.push(value.interval); //moment(value.interval.date).format('DD/MM/YYYY'));
                            dataChart.datasets[0].data.push(value.value);
                        });
                        this.chartPdaWithSessionByDay = dataChart;
                        this.isActiveChart3 = false;
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            getFineAndIfByDay() {
                axios.get('/api/dashboard/chartFineAndIfByDay?start=' + this.dateStart + '&end=' + this.dateEnd
                    + '&line=' + this.line.id)
                    .then(result => {
                        let dataChart = {
                            labels: [],
                            datasets: [
                                {
                                    label: 'Quittances',
                                    backgroundColor: '#f87979',
                                    data: []
                                },
                                {
                                    label: 'Procès-verbaux',
                                    backgroundColor: '#185578',
                                    data: []
                                },
                            ],
                        };
                        _.forEach(result.data, value => {
                            dataChart.labels.push(value.interval); //moment(value.interval.date).format('DD/MM/YYYY'));
                            dataChart.datasets[0].data.push(value.totalFines);
                            dataChart.datasets[1].data.push(value.totalIfs);
                        });
                        this.chartFineAndIfByDay = dataChart;
                        this.isActiveChart4 = false;
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            getChartRatioControlAndFineByDay() {
                axios.get('/api/dashboard/ratioBetweenControlAndViolation?start=' + this.dateStart + '&end=' + this.dateEnd
                    + '&line=' + this.line.id)
                    .then(result => {
                        let dataChart = {
                            labels: [],
                            datasets: [
                                {
                                    label: 'Taux de fraude',
                                    backgroundColor: '#2E8B57',
                                    data: []
                                }
                            ],
                        };
                        _.forEach(result.data, value => {
                            dataChart.labels.push(value.interval); //moment(value.interval.date).format('DD/MM/YYYY'));
                            dataChart.datasets[0].data.push(value.value);
                        });
                        this.chartRatioControlAndFineByDay = dataChart;
                        this.isActiveChart5 = false;
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            async getTotalOfTrashChannel() {
                let trashChannel = await axios.get('/api/dashboard/trashChannels');
                this.arrayTrashChannels = trashChannel.data;
                this.totalTrashChannel = this.arrayTrashChannels.length;
            },

            async getTotalOfViolationNotExported() {
                let arrayViolationNotExport = await axios.get('/api/dashboard/violations');
                this.arrayViolationNotExport = arrayViolationNotExport.data;
            },

            openModalNotExported() {
                this.showModalNotExported = true;
            },

            hideModalNotExported() {
                this.showModalNotExported = false;
            },

            openModalNotIntegrate() {
                this.showModalNotIntegrate = true;
            },

            hideModalNotIntegrate() {
                this.showModalNotIntegrate = false;
            },

            openModalDetail(data) {
                this.currentTrashChannel = data;

                let parser = new DOMParser();
                let xmlData = parser.parseFromString(this.currentTrashChannel.data, "text/xml");
                xmlData = vkbeautify.xml(xmlData.documentElement.outerHTML);
                this.currentTrashChannel.data = xmlData;
                this.showModalDetail = true;
            },

            hideModalDetail() {
                this.showModalDetail = false;
            },

            formatDate(dateToFormat) {
                const [dayName, monthName, day, hour, timezone, year] = dateToFormat.split(" ");
                dateToFormat = `(${monthName} ${day} ${hour} ${year})`;
                return moment(dateToFormat, 'MMM DD HH:mm:ss YYYY').format('DD/MM/YYYY');
            },

            openFineDetailsModal(fineId) {
                this.fineId = fineId;
                this.showFineDetailsModal = true;
            },

            openIfDetailsModal(ifId) {
                this.ifId = ifId;
                this.showIfDetailsModal = true;
            },

            closeFineDetailsModal() {
                this.showFineDetailsModal = false;
            },

            closeIfDetailsModal() {
                this.showIfDetailsModal = false;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .parent {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        color: white;
    }

    .tile {
        width: 220px;

        text-align: center;

        .tile-value, .tile-title {
            color: #fff;
            display: block;
        }

        .tile-value {
            font-size: 3rem;
        }

        .tile-title {
            font-size: 1.5rem;
        }
    }

    .customLoader {
        z-index: 0 !important;
    }

    .alignContent {
        text-align-last: center;
    }

    .fa-search {
        cursor: pointer;
    }

    .btnDetails {
        text-align: right;
    }

    .divDisplay {
        overflow: scroll;
        height: 500px;
        background-color: rgba(211, 211, 211, 0.5);
        color: black;
    }

    pre {
        overflow: initial;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/Dashboard.vue